var Class       = require("Class"),
    Events      = require("Events"),
    Utils       = require("Utils"),
    // $           = require("jquery"),
    ol          = require("openlayers");
require('./OMJSModifyInteraction');

// TODO переводить подсказки, если снова будут использоваться
var Measurement = Class.extend({

    includes: Events,


    /**
     *
     * @param map
     * @param view
     * @param options
     */
    initialize: function(map, view, options){
        var that = this;

        options || (options = {});

        that.setOptions(options);

        that._map = map;
        that._view = view;

        that.drawing = undefined;
        that.sketch = undefined;

        that._onDrawStart = that._onDrawStart.bind(this);
        that._onDrawEnd = that._onDrawEnd.bind(this);
        that._onModifyStart = that._onModifyStart.bind(this);
        that._onModifyEnd = that._onModifyEnd.bind(this);
        that._onModifyRemovePoint = that._onModifyRemovePoint.bind(this);
        that._onPointGeomChange = that._onPointGeomChange.bind(this);
        that.pointerMoveHandler = that.pointerMoveHandler.bind(this);
        that._finishDrawing = that._finishDrawing.bind(this);
        that.addModifyInteractionForFeature = that.addModifyInteractionForFeature.bind(this);

        /* Простой флаг, который показывает редактируем 
            мы сейчас геометрию или нет */
        that.modifying_now = false;

        that.modify_interactions = [];
        // that.translate_interactions = [];

        /* флаг для Circle геометрии. Нужен для того чтобы отличать КАК мы
            изменяем геометрию (перетаскиваем или изменяем размеры). Это нужно
            для того чтобы отличать когда нужно менять позицию тултипу,
            а когда нет */
        that.isDraggingCircleCenter = false;

        that._hTooltipEl = undefined;
        that._hTooltip = undefined;

        that._mTooltipEl = undefined;
        that._mTooltip = undefined;

        that.featureIdCounter = 0;

        /* Параметр для правильного отображения tooltip.
            По дефолту ol рисует новые tooltip под старыми.*/
        that.zTooltipIndex = 1;

        that.coordsFormats = [
            '4326',
            '4326d',
            '4326i'
        ];

        that.switchCoordsFormat = function(current_format){
           current_format++;
           if (current_format > that.coordsFormats.length - 1){
               current_format = 0;
           }
           return current_format;
        }

        // Укажите начальную точку измерения
        // Двойной клик для завершения измерения

        that.MESSAGE = {
            START: {
                MOBILE: {}
            },
            CONTINUE: {
                MOBILE: {}
            }
        };

        that.MESSAGE.CONTINUE[ol.geom.GeometryType.POLYGON] = 
        that.MESSAGE.CONTINUE[ol.geom.GeometryType.LINE_STRING] = 
            'Правый клик для завершения измерения';

        that.MESSAGE.CONTINUE.MOBILE[ol.geom.GeometryType.POLYGON] = 
        that.MESSAGE.CONTINUE.MOBILE[ol.geom.GeometryType.LINE_STRING] = 
            'Двойной тап для завершения измерения';

        that.MESSAGE.CONTINUE[ol.geom.GeometryType.POINT] = 
        that.MESSAGE.CONTINUE[ol.geom.GeometryType.CIRCLE] = 
            'Клик для завершения измерения';

        that.MESSAGE.CONTINUE.MOBILE[ol.geom.GeometryType.POINT] = 
        that.MESSAGE.CONTINUE.MOBILE[ol.geom.GeometryType.CIRCLE] = 
            'Тап для завершения измерения';


        // that.continuePolygonMsg = 'Двойной клик для завершения измерения';
        // that.continueLineMsg = 'Двойной клик для завершения измерения';
        // that.continueCircleMsg = 'Клик для завершения измерения';

        // that.mobile_continuePolygonMsg = 'Двойной тап для завершения измерения';
        // that.mobile_continueLineMsg = 'Двойной тап для завершения измерения';
        // that.mobile_continueCircleMsg = 'Тап для завершения измерения';        

        that.toolTips = {};

        that.isTouch = false;
        try {
            document.createEvent("TouchEvent");
            that.isTouch = true;
        }
        catch (e) {}

        that.currientInteraction = false;

        that.source = new ol.source.Vector();

        that.vector = new ol.layer.Vector({
            source: that.source,
            style : that.getLayerStyle()
        });

        /* стиль для OMJSModifyInteraction */
        that.modifyStyle = that.getModifyStyle();

        /* стиль для ol.interacion.Draw */
        that.drawingStyle = [
            new ol.style.Style({
                stroke: new ol.style.Stroke({
                    color: '#ffffff',
                    width: 10,
                }),
            }),
            new ol.style.Style({
                fill: new ol.style.Fill({
                    color: 'rgba(90, 160, 180, 0.2)'
                }),
                stroke: new ol.style.Stroke({
                    color: /*'#6666ff'*/'#0086b3',
                    lineDash: [5, 5],
                    width: 2
                }),
                image: new ol.style.Circle({
                    radius: 5,
                    stroke: new ol.style.Stroke({
                        color: 'rgba(0, 0, 0, 0.7)'
                    }),
                    fill: new ol.style.Fill({
                        color: 'rgba(255, 255, 255, 0.6)'
                    })
                })
            })
        ];
    },

    getLayerStyle: function(scale) {

        if (scale === undefined) {
            scale = 1;
        }

        var circle = new ol.style.Circle({
            radius: 6 * scale,
            fill  : new ol.style.Fill({
                color: /*'#6666ff*/'#0086b3'
            }),
            stroke: new ol.style.Stroke({
              color: [255, 255, 255, 1],
              width: 3 * scale
            })
        });

        if (scale !== 1) {
            circle.setScale(1 / scale);
        }

        return [
            /* стиль для дополнительной обводки */
            new ol.style.Style({
                stroke: new ol.style.Stroke({
                    color: '#ffffff',
                    width: 10,
                }),
            }),
            /* обычный стиль */
            new ol.style.Style({
                fill  : new ol.style.Fill({
                    color: 'rgba(0, 134, 179, 0.2)'
                }),
                stroke: new ol.style.Stroke({
                    color: '#0086b3',
                    width: 4
                }),
                image : circle
            })
        ];
    },

    getModifyStyle: function(scale) {

        if (scale === undefined) {
            scale = 1;
        }

        var image = new ol.style.Circle({
            radius: 6 * scale,  /* различие между двумя стилями */
            fill: new ol.style.Fill({
                color: /*'#6666ff'*/'#0086b3'
            }),
            stroke: new ol.style.Stroke({
                color: [255, 255, 255, 1],
                width: 3 * scale
            })
        });

        if (scale !== 1) { 
            image.setScale(1 / scale); 
        }

        return new ol.style.Style({
            image: image
        });
    },

    /**
     * Функция для клонирования слоев на которых рисуется геометрия
     * @param  {number} scale  - для стилей
     * @return {ol.layer.Vector[]}
     */
    clone: function(scale) {
        var that = this;
        var layers = [];

        scale = scale === undefined ? 1 : scale;

        var main_geometry_layer = Utils.cloneVectorLayer(that.vector);
            main_geometry_layer.setStyle( that.getLayerStyle(scale) );

        layers.push(main_geometry_layer);

        if (
            that.modify_interactions 
            && that.modify_interactions.length
        ) {
            for (var i = 0; i < that.modify_interactions.length; i++) {
                var modification = that.modify_interactions[i];
                if (modification instanceof ol.interaction.OMJSModify) {
                    var vertex_layer = Utils.cloneVectorLayer(
                        modification.custom_vertex_overlay_,
                        {
                            useSpatialIndex: false
                        }
                    );
                    var new_style = that.getModifyStyle(scale);
                    vertex_layer.setStyle(new_style);
                    layers.push(vertex_layer);
                }
            }    
        }
        
        return layers;
    },

    

    _getContinueMessage: function(mobile, geom_type){
        var that = this;
        if (!!mobile) {
            return that.MESSAGE.CONTINUE.MOBILE[geom_type];
        } else {
            return that.MESSAGE.CONTINUE[geom_type];
        }
    },

    _getStartMessage: function(mobile, geom_type){
        var that = this;
        if (!!mobile) {
            return that.MESSAGE.START.MOBILE[geom_type];
        } else {
            return that.MESSAGE.START[geom_type];
        }
    },

    _dblClickZoomActive: function(active){
        var that = this;
        var interactions = that._map.getInteractions();
        for (var i = 0; i < interactions.getLength(); i++) {
            var interaction = interactions.item(i);                          
            if (interaction instanceof ol.interaction.DoubleClickZoom) {
                interaction.setActive(active);
            }
        }
    },

    /**
     *
     * @param polygon
     * @return {*}
     */
    getArea: function(polygon){
        var that = this,
            area,
            sourceProj,
            geom,
            coordinates,
            output;

        sourceProj = that._map.getView().getProjection();

        area = Math.abs(ol.sphere.getArea(polygon));

        if(area > 10000){
            output = 'S = ' + (Math.round(area / 1000000 * 100) / 100) +
                     ' ' + that._view.Lang.translate('км<sup>2</sup>');
        }else{
            output = 'S = ' + (Math.round(area * 100) / 100) +
                     ' ' + that._view.Lang.translate('м<sup>2</sup>');
        }
        return output;
    },

    /**
     *
     * @param line
     * @return {*}
     */
    getLength: function(line){

        var that = this,
            length,
            coordinates,
            sourceProj,
            i, ii, c1, c2,
            output;

        coordinates = line.getCoordinates();
        length = 0;
        sourceProj = that._map.getView().getProjection();

        for(i = 0, ii = coordinates.length - 1; i < ii; ++i){
            c1 = ol.proj.transform(coordinates[i], sourceProj, 'EPSG:4326');
            c2 = ol.proj.transform(coordinates[i + 1], sourceProj, 'EPSG:4326');
            length += ol.sphere.getDistance(c1, c2);
        }

        if(length > 100){
            output = 'L = ' + (Math.round(length / 1000 * 100) / 100) +
                     ' ' + that._view.Lang.translate('км');
        }else{
            output = 'L = ' + (Math.round(length * 100) / 100) +
                     ' ' + that._view.Lang.translate('м');
        }
        return output;
    },

    getPointCoords: function(geometry, mode){
        var that = this;
        var coordinates = geometry.getCoordinates();
        var sourceProj = that._map.getView().getProjection();
        var convertedCoords;
        var output;

        switch(mode){
            case '4326d':
                convertedCoords = that._ddToDms(ol.proj.transform(coordinates, sourceProj, 'EPSG:4326').reverse());
                return convertedCoords.join(", ");
            case '4326i':
                convertedCoords = ol.proj.transform(coordinates, sourceProj, 'EPSG:4326');
                return ol.coordinate.format(convertedCoords, '{y}, {x}', 6);
                return
            default:
                convertedCoords = ol.proj.transform(coordinates, sourceProj, 'EPSG:4326');
                return ol.coordinate.format(convertedCoords, 'X = {x}<br />Y = {y}', 6);
        }

        return output;
    },

    _ddToDms: function (coords) {
        var that = this;
        var lat  = coords[0];
        var lng  = coords[1];
        var latResult, lngResult, dmsResult;

        lat = parseFloat(lat);
        lng = parseFloat(lng);

        latResult = (lat >= 0) ? 'N ' : 'S ';

        // Call to getDms(lat) function for the coordinates of Latitude in DMS.
        // The result is stored in latResult variable.
        latResult += that._getDms(lat);

        lngResult = (lng >= 0) ? 'E ' : 'W ';

        // Call to getDms(lng) function for the coordinates of Longitude in DMS.
        // The result is stored in lngResult variable.
        lngResult += that._getDms(lng);

        // Joining both variables and separate them with a space.
        dmsResult = latResult + ' ' + lngResult;

        // Return the resultant string
        return [latResult, lngResult];
    },

    _getDms: function (val) {
        var valDeg, valMin, valSec, result;

        val = Math.abs(val);

        valDeg = Math.floor(val);
        result = valDeg + "º";

        valMin = Math.floor((val - valDeg) * 60);
        result += valMin + "'";

        valSec = Math.round((val - valDeg - valMin / 60) * 3600 * 1000) / 1000;
        result += valSec + '"';

        return result;
    },

    _getCircleRadiusInMeters: function(circle_geom){
        if (circle_geom.getType() !== ol.geom.GeometryType.CIRCLE) {
            return false;
        }
        var that = this;
        var center = circle_geom.getCenter();
        var radius = circle_geom.getRadius();
        var edgeCoordinate = [center[0] + radius, center[1]];
        var groundRadius = ol.sphere.getDistance(
            ol.proj.transform(center, 'EPSG:3857', 'EPSG:4326'), 
            ol.proj.transform(edgeCoordinate, 'EPSG:3857', 'EPSG:4326')
        );
        if(groundRadius > 100){
            groundRadius = 'R = ' + (Math.round(groundRadius / 1000 * 100) / 100) +
                ' ' + that._view.Lang.translate('км');
        }else{
            groundRadius = 'R = ' + groundRadius.toFixed(6) +
                ' ' + that._view.Lang.translate('м');
        }
        return groundRadius;
    },

    /**
     *
     * @param evt
     */
    pointerMoveHandler: function(evt){

        var that    = this,
            helpMsg = 'Укажите начальную точку измерения',
            tooltipCoord,
            output,
            geom;

        if (evt.geom) {
            geom = evt.geom;
        } else if (that.sketch) {
            geom = (that.sketch.getGeometry());
        }

        if(
            (evt.dragging && !that.isTouch && !that.modifying_now)
            || (geom && geom.getType() == ol.geom.GeometryType.POINT)
        ){
            return;
        }

        // if (that._getActive(that.modify_interactions)) {
        //     that.highlightDots(evt);
        // }

        tooltipCoord = evt.coordinate;

        if(that.sketch){
            switch (geom.getType()) {
                /* Если геометрия типа POLYGON */
                case ol.geom.GeometryType.POLYGON:
                    output = that.getArea(geom);

                    helpMsg = that.isTouch 
                            ? that._getContinueMessage(true, geom.getType())
                            : that._getContinueMessage(false, geom.getType());

                    tooltipCoord = geom.getInteriorPoint().getCoordinates();
                    break;

                /* Если геометрия типа LINE_STRING */
                case ol.geom.GeometryType.LINE_STRING:
                    output = that.getLength(geom);

                    helpMsg = that.isTouch 
                            ? that._getContinueMessage(true, geom.getType())
                            : that._getContinueMessage(false, geom.getType());

                    tooltipCoord = geom.getLastCoordinate();
                    break;

                /* Если геометрия типа CIRCLE */
                case ol.geom.GeometryType.CIRCLE:
                    output = that._getCircleRadiusInMeters(geom);

                    helpMsg = that.isTouch 
                            ? that._getContinueMessage(true, geom.getType())
                            : that._getContinueMessage(false, geom.getType());

                    var circleCenter_ = geom.getCenter();

                    if (!that.isDraggingCircleCenter) {
                        /* если мы тащим круг не за центр (т.е. не перемещаем,
                            действительно изменяем геометрию) */
                        

                        var firstCoordinate = geom.getLastCoordinate();
                        var angle = Math.atan2(
                                firstCoordinate[1]-circleCenter_[1], 
                                firstCoordinate[0]-circleCenter_[0]
                            ) - Math.atan2(
                                tooltipCoord[1] - circleCenter_[1], 
                                tooltipCoord[0] - circleCenter_[0]
                            );
                        tooltipCoord = evt.coordinate;

                        geom.set('tooltipAngle', -angle, true);
                    } else {
                        /* если мы перемещаем круг (тащим куда-то за центр), то
                            мы должны высчитать новую координату для тултипа
                            используя угол, на котором у нас находится тултип */

                        tooltipCoord = [
                            circleCenter_[0] + (geom.getRadius() * Math.cos(geom.get('tooltipAngle'))),
                            circleCenter_[1] + (geom.getRadius() * Math.sin(geom.get('tooltipAngle')))
                        ];

                    }

                    // tooltipCoord = geom.getCenter();
                    break;

                // /* Если геометрия типа POINT */
                // case ol.geom.GeometryType.POINT:
                //     output = that.getPointCoords(geom);

                //     helpMsg = that.isTouch 
                //             ? that._getContinueMessage(true, geom.getType())
                //             : that._getContinueMessage(false, geom.getType());

                //     tooltipCoord =  geom.getLastCoordinate();
                //     break;
            }

            if (that.sketch) {
                var tooltip = that.toolTips[that.sketch.getId()];
                tooltip.getElement().innerHTML = output;
                tooltip.setPosition(tooltipCoord);
            }
        } else {
            if (that.isTouch)  {
                // that._hTooltipEl.style.display = 'none';
                return;
            }
        }

         // выставляем позицию только если мы в данный момент рисуем
         //    и рисуем HE точку 
        // if (that.drawing.getActive()) {
            /* не выставляем хелпер тултип если мы на таче и рисуем точку */
            // if (that.sketch 
                // && geom.getType() == ol.geom.GeometryType.POINT 
                // && that.isTouch) {
                // return;
            // }
            // that._hTooltipEl.style.display = '';
            // that._hTooltipEl.innerHTML = helpMsg;
            // that._hTooltip.setPosition(evt.coordinate);
        // } else {
            // that._hTooltipEl.style.display = 'none';
        // }
        
    },

    /**
     *
     */
    // createHelpTooltip: function(){
    //     var that = this;

    //     if(that._hTooltipEl){
    //         that._hTooltipEl.parentNode.removeChild(that._hTooltipEl);
    //     }
    //     that._hTooltipEl = document.createElement('div');
    //     that._hTooltipEl.className = 'omjs-tooltip';
    //     that._hTooltip = new ol.Overlay({
    //         element    : that._hTooltipEl,
    //         offset     : [15, 0],
    //         positioning: 'center-left'
    //     });
    //     that._map.addOverlay(that._hTooltip);
    // },

    /**
     *
     */
    createMeasureTooltip: function(){
        var that = this;
        //that._mTooltipEl
        //that._mTooltip
        var tooltip_el = document.createElement('div');

        // omjs-tooltip tooltip-static
        tooltip_el.className = 'omjs-tooltip tooltip-static measurement-tooltip';
        // задаем правильный порядок отображения
        tooltip_el.style.zIndex = that.zTooltipIndex;

        var tooltip = new ol.Overlay({
            element    : tooltip_el,
            offset     : [0, -15],
            positioning: 'bottom-center',
        });
        that._map.addOverlay(tooltip);
        return tooltip;
    },

    /**
     *
     * @param itype
     */
    createInteraction: function(itype){
        var that = this,
            type;

        that._view.on('finish_drawing', that._finishDrawing);

        switch(itype) {
            case 'Circle':
                type = itype = that.draw_type = ol.geom.GeometryType.CIRCLE;
                break;
            case 'Point':
                type = itype = that.draw_type = ol.geom.GeometryType.POINT;
                break;
            case 'area':
                type = itype = that.draw_type = ol.geom.GeometryType.POLYGON;
                break;
            case 'distance':
                type = itype = that.draw_type = ol.geom.GeometryType.LINE_STRING;
                break;
            default:
                type = itype = that.draw_type = ol.geom.GeometryType.POINT;
                break;
        }

        that.drawing = that.createDrawInteraction(
                that.source,
                that.drawingStyle,
                type
            );

        that._map.addInteraction(that.drawing);

        // that.createHelpTooltip();

        that.drawing.on('drawstart', that._onDrawStart);
        that.drawing.on('drawend', that._onDrawEnd);

        
    },

    createDrawInteraction: function(source, style, type){
        var that = this;
        var drawInteraction;
        drawInteraction = new ol.interaction.Draw({
            source: source,
            style: style,
            type: type,
            geometryFunction: function(coords, geom){
                if (type == ol.geom.GeometryType.CIRCLE) {
                    var circle = geom ? (geom) : new ol.geom.Circle([NaN, NaN]);
                    var squaredLength = ol.coordinate.squaredDistance(
                        coords[0], coords[1]);
                    circle.setCenterAndRadius(coords[0], Math.sqrt(squaredLength));
                    return circle;
                } else {
                    if (!geom) {
                        geom = new ol.geom[type](coords);
                    }
                    geom.setCoordinates(coords);
                    if (that.isTouch) {
                        that.pointerMoveHandler({
                            coordinate: geom.getLastCoordinate(),
                            geom: geom
                        });
                    }
                    return geom;
                }
            }
        });

        return drawInteraction;
    },

    _onDrawStart: function(evt){
        var that = this;
        /* На время рисовки отключаем зум по двойному */
        that._dblClickZoomActive(false);
        that.sketch = evt.feature;
        that.sketch.setId(++that.featureIdCounter);
        var geom = that.sketch.getGeometry();

        var tooltip = that.createMeasureTooltip();
        var tooltipId = evt.feature.getId();
        that.toolTips[tooltipId] = tooltip;

        if (geom.getType() == ol.geom.GeometryType.POINT) {
            tooltip.coordsFormat = 0;

            that._onPointGeomChange({
                target: geom
            });

            $(tooltip.getElement()).on('click', '.switch-coords-format', function(){
                tooltip.coordsFormat = that.switchCoordsFormat(tooltip.coordsFormat);

                that._onPointGeomChange({
                    target: geom
                }, tooltipId);
            });

            // that.pointerMoveHandler({
            //     geom: geom,
            //     feature: evt.feature
            // });
        }
        if (
                that.isTouch
                /* не выполняем вызов pointerMove второй раз */
                && geom.getType() != ol.geom.GeometryType.POINT
            ) {
            that.pointerMoveHandler({
                coordinate: geom.getLastCoordinate(),
                geom: geom,
                feature: evt.feature
            });
        }
        that.fire('drawstart', evt);
        // инкрементируем параметр для будущих tooltip
        that.zTooltipIndex += 1;
    },
    _onDrawEnd: function(evt){
        var that = this;
        /* Включаем зум по двойному клику после того 
            как мы закончили рисовать */
        setTimeout(function(){
            that._dblClickZoomActive(true);
        }, 10);

        if (that.isTouch)  {
            // that._hTooltipEl.style.display = 'none';

            var geom = evt.feature.getGeometry();
            that.pointerMoveHandler({
                coordinate: geom.getLastCoordinate(),
                geom: geom,
                feature: evt.feature
            });
        }
        // that._mTooltipEl.className = 'omjs-tooltip tooltip-static';
        // that._mTooltip.setOffset([0, -7]);

        that.sketch = null;
        that.createMeasureTooltip();

        var feature = evt.feature;
        var feature_geom = feature.getGeometry();

        if (feature_geom.getType() == ol.geom.GeometryType.POLYGON) {
            /* """""фикс"""""
                при редактировании нарисованной геометрии куда-то 
                пропадает возможность редактирования последнего сегмента
                геометрии. Тут мы просто добавляем первую координату в 
                конец геометрии чтобы "замкнуть" полигон.
             */
            var polygon_coords = feature_geom.getCoordinates()[0];
            var first_coord = polygon_coords[0];
            polygon_coords.push(first_coord);
            feature.setGeometry(new ol.geom.Polygon([polygon_coords]));
        }
        

        that.fire('drawend', evt);
    },

    _finishDrawing: function(event){
        var that = this;
        if (that.drawing && that.drawing.getActive()) {
            that.drawing.addToDrawing_(event);
            that.drawing.finishDrawing();
        }
    },

    // _convertToPointerUpEvent: function(event) {
    //     var originalEvent = event.originalEvent;
    //     event.type = 'pointerup';

    //     return event;
    // },

    _onPointGeomChange: function(event, tooltip_id){
        var that = this;
        var tooltipCoord, 
            geom = event.target,
            output,
            helpMsg;
        /* Если геометрия типа POINT */
        tooltip_id = tooltip_id || that.sketch.getId();
        var tooltip = that.toolTips[tooltip_id];

        output = '<div>' + that.getPointCoords(geom, that.coordsFormats[tooltip.coordsFormat]) + '</div>';
        output += '<div class="switch-coords-format" title="' +
            that._view.Lang.translate('Сменить формат координат') + '" />';
    
        helpMsg = that.isTouch 
                ? that._getContinueMessage(true, geom.getType())
                : that._getContinueMessage(false, geom.getType());
    
        tooltipCoord =  geom.getCoordinates();


        tooltip.getElement().innerHTML = output;
        tooltip.setPosition(tooltipCoord);
    },

    activateModifyInteraction: function(created_feature){
        var that = this;

        that.drawing.setActive(false);

        if (created_feature) {
            // мы добавили новую фичу, нужно для нее добавить interaction
            this.addModifyInteractionForFeature(created_feature);
            if (created_feature.getGeometry().getType() == ol.geom.GeometryType.POINT) {
                created_feature.getGeometry().on('change', that._onPointGeomChange);
            }
        }

        if (!that.modify_interactions.length) {
            created_feature = created_feature ? [created_feature] : [];

            var source_features = [].concat(
                                        that.source.getFeatures(),
                                        created_feature
                                    );

            _.each(source_features, function(feature){
                var feature_geom = feature.getGeometry();
                if (feature_geom.getType() == ol.geom.GeometryType.POINT) {
                    feature_geom.on('change', that._onPointGeomChange);
                }
            });

            that._regenerateModifyInteractions(source_features);

            /* Генерируем по 1 ol.interaction.Translate на 1 фичу */
            // TODO: выключено до того как поймем как сделать так чтобы
            //      interaction'ы не конфликтовали между собой.
            // _.each(polygon_features, function(polygonFeature){
            //     var interaction = new ol.interaction.Translate({
            //         features: new ol.Collection([polygonFeature]),
            //         hitTolerance: 1
            //     });

            //     interaction.on('translatestart', that._onTranslateStart, that);
            //     interaction.on('translateend',   that._onTranslateEnd,   that);

            //     that.translate_interactions.push(interaction);
            //     that._map.addInteraction(interaction);
            // });
        } else {
            that._setActive(that.modify_interactions, true);
        }
    },

    deactivateModifyInteraction: function(without_removing){
        var that = this;
        if (without_removing) {
            if (that.modify_interactions.length) {
                that._setActive(that.modify_interactions, false);
            }
        } else {
            /* Убираем все interaction для перемещения полигонов */
            // that._removeInteraction(that.translate_interactions);

            /* Убираем все interaction по модифицированию геометрии */
            that._removeInteraction(that.modify_interactions);
            
            that.modify_interactions = [];
            // that.translate_interactions = [];
        }
        /* Включаем рисование обратно */
        that.drawing.setActive(true);
    },

    _regenerateModifyInteractions: function(features){
        /* Генерируем по 1 ol.interaction.OMJSModify на 1 фичу */
        _.each(features, this.addModifyInteractionForFeature);
    },

    addModifyInteractionForFeature: function(feature){
        var that = this;
        var feature_geom_type = feature.getGeometry().getType();
        var interaction;
        /* Если это линия или полигон, то подставляем модифицированную
            версию ol.interaction.Modify */
        if (ol.interaction.OMJSModify.AVAILABLE_GEOMTYPES
                                    .indexOf(feature_geom_type) != -1) 
        {
            interaction = new ol.interaction.OMJSModify({
                features: new ol.Collection([feature]),
                style: that.modifyStyle
            });
        } else {
            interaction = new ol.interaction.Modify({
                features: new ol.Collection([feature]),
                style: that.modifyStyle
            });
        }
        this.modify_interactions.push(interaction);

        interaction.on('modifystart',   this._onModifyStart);
        interaction.on('modifyend',     this._onModifyEnd);
        interaction.on('removepoint',   this._onModifyRemovePoint);

        this._map.addInteraction(interaction);
    },

    _onModifyStart: function(event){
        var that = this;

        that.modifying_now = true;
        that.sketch = event.features.item(0);

        // TODO: вынести в OMJSInteraction (начало)
        var sketchGeometry = that.sketch.getGeometry(),
            _interaction = event.target,
            fromGeomCenterDistance = 0;

        if (
            sketchGeometry.getType() == ol.geom.GeometryType.CIRCLE
            && _interaction instanceof ol.interaction.Modify
        ) {
            fromGeomCenterDistance = ol.coordinate.distance(
                that._map.getPixelFromCoordinate(sketchGeometry.getCenter()),
                event.mapBrowserEvent.pixel
            );

            if (fromGeomCenterDistance < _interaction.pixelTolerance_) {
                that.isDraggingCircleCenter = true;
            } else {
                that.isDraggingCircleCenter = false;
            }
        } else {
            that.isDraggingCircleCenter = false;
        }
        event.isDraggingCircleCenter = that.isDraggingCircleCenter;
        // TODO: вынести в OMJSInteraction (конец)

        that.fire('modifystart', event);

    },

    _onModifyEnd: function(event){
        var that = this;

        that.modifying_now = false;
        that.sketch = false;
        that.isDraggingCircleCenter = false;

        var feature = event.features.item(0);
        var feature_geom = feature.getGeometry();
        that.pointerMoveHandler({
            coordinate: feature_geom.getLastCoordinate(),
            geom: feature_geom,
            feature: feature
        });

        that.fire('modifyend', event);
    },

    _onModifyRemovePoint: function(event){
        var features = event.features;
        var feature = features.item(0);
        var feature_geom = feature.getGeometry();
        var toolTip = this.toolTips[feature.getId()];
        switch (feature_geom.getType()) {
            case ol.geom.GeometryType.POLYGON:
                toolTip.setPosition(feature_geom.getInteriorPoint().getCoordinates());
                toolTip.getElement().innerHTML = this.getArea(feature_geom);
                break;

            case ol.geom.GeometryType.LINE_STRING:
                toolTip.setPosition(feature_geom.getLastCoordinate());
                toolTip.getElement().innerHTML =this.getLength(feature_geom);
                break;
        }
    },

    _onTranslateStart: function(event) {
        var that = this;

        that.modifying_now = true;
        that.sketch = event.features.item(0);

        that.fire('translatestart', event);

    },

    _onTranslateEnd: function(event){
        var that = this;

        that.modifying_now = false;
        that.sketch = false;

        that.fire('translateend', event);
    },

    generateDistanceTooltip: function(geometry){
        var that = this;
        var outerElement = document.createElement('div');
            outerElement.className = 'omjs-tooltip tooltip-static';

        var olOverlay = new ol.Overlay({
            element    : outerElement,
            offset     : [0, -7],
            positioning: 'bottom-center'
        });

        switch(geometry.getType()) {
            case ol.geom.GeometryType.CIRCLE:
                outerElement.textContent = that._getCircleRadiusInMeters(
                                                    geometry
                                                );

                olOverlay.setPosition(geometry.getCenter());
                break;
            case ol.geom.GeometryType.POINT:
                outerElement.innerHTML = that.getPointCoords(geometry, '4326');
                olOverlay.setPosition(geometry.getCoordinates());
                break;
            case ol.geom.GeometryType.POLYGON:
                outerElement.innerHTML = that.getArea(geometry);
                olOverlay.setPosition(
                    geometry.getInteriorPoint().getCoordinates()
                );
                break;
            case ol.geom.GeometryType.LINE_STRING:
                outerElement.textContent = that.getLength(geometry);
                olOverlay.setPosition(geometry.getLastCoordinate());
                break;
            default:
                return false;
        }

        return olOverlay;
    },

    /**
     *
     * @param itype
     */
    changeInteraction: function(interactionType){
        var that = this;

        if(that.currientInteraction == interactionType){
            if (!!that.modify_interactions.length 
                && !that._getActive(that.modify_interactions)) {
                that._setActive(that.modify_interactions, true);
            }
            // that.stopInteraction();
        } else {
            if(that.currientInteraction == false){
                /* добавляем новый слой и подписываемся на ивенты только если
                    у нас уже векторный слой не добавлен на карту
                    это нужно для того чтобы отличать когда у нас есть 
                    ol.interaction.Draw на карте а когда нет. Нужно чтобы
                    мы могли отключить режим рисования посреди процесса 
                    рисования */
                if (!_.contains(that._map.getLayers().getArray(), that.vector)) {
                    that._map.addLayer(that.vector);
                    if (that.isTouch) {
                        that._map.on('pointerdrag', that.pointerMoveHandler);
                    } else {
                        that._map.on('pointermove', that.pointerMoveHandler);
                    }
                }
            }else{
                that._map.removeInteraction(that.drawing);
                that.drawing = false;
            }
            that.createInteraction(interactionType);
            that.currientInteraction = interactionType;
            that.fire('measureChanged', {measureType: interactionType});
        }
    },

    /**
     *
     */
    stopInteraction: function(){
        var that = this;

        that.sketch = null;
        that.featureIdCounter = 0;
        that._map.un('pointermove', that.pointerMoveHandler);
        that._map.un('click', that.pointerMoveHandler);
        that._view.off('finish_drawing', that._finishDrawing);
        that._map.removeInteraction(that.drawing);
        if (!!that.modify_interactions.length) {
            that._removeInteraction(that.modify_interactions);
            that.modify_interactions = [];
        }
        // that._map.removeOverlay(that._hTooltip);

        //$(that._mTooltip.getElement()).remove();
        //that._mTooltipEl = void(0);
        //that._hTooltip = void(0);
        //that._mTooltip = void(0);

        that._map.removeLayer(that.vector);
        that.source.clear();
        that.currientInteraction = false;

        _.each(that.toolTips, function(tooltip){
            that._map.removeOverlay(tooltip);
        });
        that.toolTips = {};

        that.fire('measureChanged', {measureType: false});
    },

    stopDrawInteraction: function(){
        var that = this;
        that._view.off('finish_drawing', that._finishDrawing);
        if (that.drawing) {
            that._map.removeInteraction(that.drawing);
            that.drawing = false;
            that.currientInteraction = false;
        }
        if (that.sketch) {
            that.sketch = false;
            var toolTipKeys = _.keys(that.toolTips);
            that._map.removeOverlay(
                that.toolTips[toolTipKeys[toolTipKeys.length - 1]]
            );
        }
        // that._map.removeOverlay(that.toolTips.pop());
    },

    _setActive: function(interactions_array, value){
        _.each(interactions_array, function(interaction){
            interaction.setActive(value);
        });
    },

    _getActive: function(interactions_array){
        var _active = true;
        for (var i = 0; i < interactions_array.length; i++) {
            _active = _active && interactions_array[i].getActive();
            if (!_active) break; 
        }
        return _active;
    },

    _removeInteraction: function(interactions_array){
        var that = this;
        _.each(interactions_array, function(interaction){
            that._map.removeInteraction(interaction);
        });
        // сбрасываем параметр порядка отображения tooltip
        that.zTooltipIndex = 1;
    },

    setVisible: function(value){
        var that = this;
        that.vector.setVisible(value);
        _.each(that.modify_interactions, function(interaction){
            if (interaction.getCustomVertexOverlay) {
                var custom_vertex = interaction.getCustomVertexOverlay();
                custom_vertex.setVisible(value);
            }
        });
    }

});

module.exports = Measurement;


//////////////////
// WEBPACK FOOTER
// ./src/View/Measurement.js
// module id = 228
// module chunks = 0